
import React, { useState, useEffect } from 'react';

const COLORS = ['bg-red-500', 'bg-blue-500', 'bg-green-500', 'bg-yellow-500', 'bg-purple-500', 'bg-pink-500'];
const SIZE = 12;

const Flood: React.FC = () => {
  const [grid, setGrid] = useState<number[][]>([]);
  const [moves, setMoves] = useState(0);

  const init = () => {
    const newGrid = Array(SIZE).fill(0).map(() => Array(SIZE).fill(0).map(() => Math.floor(Math.random() * COLORS.length)));
    setGrid(newGrid);
    setMoves(0);
  };

  useEffect(() => init(), []);

  const flood = (newColor: number) => {
    const oldColor = grid[0][0];
    if (oldColor === newColor) return;
    const newGrid = [...grid.map(row => [...row])];
    
    const fill = (r: number, c: number) => {
      if (r < 0 || r >= SIZE || c < 0 || c >= SIZE || newGrid[r][c] !== oldColor) return;
      newGrid[r][c] = newColor;
      fill(r+1, c); fill(r-1, c); fill(r, c+1); fill(r, c-1);
    };

    fill(0, 0);
    setGrid(newGrid);
    setMoves(m => m + 1);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="mb-4 text-xl font-bold">SYCLES: {moves}</div>
      <div className="grid gap-1 bg-slate-900 p-2 rounded-xl border border-slate-800" style={{ gridTemplateColumns: `repeat(${SIZE}, 1fr)` }}>
        {grid.flat().map((c, i) => <div key={i} className={`w-5 h-5 md:w-7 md:h-7 rounded-sm ${COLORS[c]}`} />)}
      </div>
      <div className="flex gap-2 mt-8">
        {COLORS.map((c, i) => (
          <button key={i} onClick={() => flood(i)} className={`w-10 h-10 rounded-full border-2 border-white/20 ${c} hover:scale-110 transition-transform`} />
        ))}
      </div>
    </div>
  );
};

export default Flood;
